var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.862.7 1.925.4a.437.437 0 0 0-.442.414.448.448 0 0 0 .414.442l8.949.273L.702 11.673a.426.426 0 0 0 .602.602L11.448 2.131l.273 8.949a.445.445 0 0 0 .442.414.433.433 0 0 0 .414-.443l-.3-9.936A.458.458 0 0 0 11.861.7z"
  })));
};
export default SvgArrowUpRight;